import * as Yup from "yup";
import { useFormik } from 'formik';

const UseCustomFormik = (selected_service, data, selectedPolicy) => {

  const selectedData = data && data.find(value => value.policy_number == selectedPolicy);
  const ValidationSchemaArray = [
    Yup.object({
      policy_fullname: Yup.string().required("*Required"),
      policy_nic:Yup.string().required("*Required"),
    
        policy_address1: Yup.string().required("*Required"),
        policy_address2:Yup.string().required("*Required"),
        // proof_description: Yup.string().required("*Required"),
        // policy_address3: Yup.string().required("*Required"),
        // policy_address4:Yup.string().required("*Required"),  
       

      
      
      
    }),
    Yup.object().shape({
      nominee: Yup.array().of(
        Yup.object().shape({
          nic: Yup.string().when('birthday', {
            is: (value) => {
              const dateComponents = value?.split('/');
              if(value){
                const BirthdayYear = parseInt(dateComponents[2], 10); // Parse as an integer
                const CurrentYear = new Date().getFullYear();
                const age = CurrentYear - BirthdayYear;
                return age > 18;
              }
             
            },
            then: (schema) => schema.required("*Required"),
          }).min(10,"Invalid NIC").max(12,"Invalid NIC"),
          
          name: Yup.string().required("*Required"),
          birthday: Yup.string().required("*Required"),
          // proof_description: Yup.string().required("*Required"),
          relationship: Yup.string().required("*Required"),
          percentage: Yup.number()
            .required("*Required")
           .moreThan(0, "Percentage must be greater than 0"),
          
        })
      )
    })
    ,

    Yup.object().shape({
      assignee: Yup.array().of(
        Yup.object().shape({
          nic: Yup.string().when('birthday', {
            is: (value) => {
              const dateComponents = value?.split('/');
              if(value){
                const BirthdayYear = parseInt(dateComponents[2], 10); // Parse as an integer
                const CurrentYear = new Date().getFullYear();
                const age = CurrentYear - BirthdayYear;
                return age > 18;
              }
             
            },
            then: (schema) => schema.required("*Required"),
          }).min(10,"Invalid NIC").max(12,"Invalid NIC"),
          name: Yup.string().required("*Required"),
          birthday: Yup.string().required("*Required"),
          relationship: Yup.string().required("*Required"),
          // proof_description: Yup.string().required("*Required"),
        })
      )
    }),
    Yup.object({

    }).shape({
      gardian: Yup.array().of(
        Yup.object().shape({
          nic: Yup.string().when('birthday', {
            is: (value) => {
              const dateComponents = value?.split('/');
              if(value){
                const BirthdayYear = parseInt(dateComponents[2], 10); // Parse as an integer
                const CurrentYear = new Date().getFullYear();
                const age = CurrentYear - BirthdayYear;
                return age > 18;
              }
             
            },
            then: (schema) => schema.required("*Required"),
          }).min(10,"Invalid NIC").max(12,"Invalid NIC"),
          name: Yup.string().required("*Required"),
          birthday: Yup.string().required("*Required"),
          relationship: Yup.string().required("*Required"),
        })
      )
    }),
    Yup.object({

    }).shape({
      beneficiaries: Yup.array().of(
        Yup.object().shape({
          nic: Yup.string().when('birthday', {
            is: (value) => {
              const dateComponents = value?.split('/');
              if(value){
                const BirthdayYear = parseInt(dateComponents[2], 10); // Parse as an integer
                const CurrentYear = new Date().getFullYear();
                const age = CurrentYear - BirthdayYear;
                return age > 18;
              }
             
            },
            then: (schema) => schema.required("*Required"),
          }).min(10,"Invalid NIC").max(12,"Invalid NIC"),
          name: Yup.string().required("*Required"),
          birthday: Yup.string().required("*Required"),
          relationship: Yup.string().required("*Required"),
        })
      )
    }),
    Yup.object({

    }),

    
 
    Yup.object({
      policy_mobile: Yup.object().shape({
        newMobile: Yup.string().required("*Required").max(10,"Invalid Contact Number").min(10,"Invalid Contact Number"),


      })
    }),

  ];





  const formik = useFormik({
    initialValues: {
  
      policy_address1:selectedData && selectedData.policy_address1,     
      policy_address2:selectedData && selectedData.policy_address2,
      policy_address3:selectedData && selectedData.policy_address3,
        policy_address4:selectedData && selectedData.policy_address4,
     
      policy_email: selectedData && selectedData.email,
      policy_gender: selectedData && selectedData.gender,
      policy_mobile: {
        oldMobile: selectedData && selectedData.mobile,
        newMobile: null,
      },
      policy_nic:selectedData && selectedData.nic,
      policy_fullname:  selectedData && selectedData.policy_fullname,
      policy_proofdoc:[],
      nominee: selectedData && selectedData.nominee,
      assignee: selectedData && selectedData.assignee,
      gardian: selectedData && selectedData.gardian,
      beneficiaries: selectedData && selectedData.beneficiaries,



    },
    validationSchema: ValidationSchemaArray[(selected_service - 1)],
  });

  return formik;
};

export default UseCustomFormik;
